import { render } from "./GroupCardContributorMain.vue?vue&type=template&id=5438b9e0"
import script from "./GroupCardContributorMain.vue?vue&type=script&lang=js"
export * from "./GroupCardContributorMain.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\a\\WebApp\\FAOU.App\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__